import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { SwitchInput } from 'common/react/components/SwitchInput';
import { getTranslation } from 'common/react/utils/translations';
import {
    leaderboardBettingToggleSelector,
    leaderboardDataSelector,
    leaderboardNavSelector
} from 'store/modules/brownlow-tracker/leaderboard/selectors';
import { UPDATE_BETTING_TOGGLE } from 'store/modules/brownlow-tracker/leaderboard/actions';
import { useGetBrownlowBettingOddsQuery } from 'store/modules/api/cfs-api';

export const BettingOddsToggle = ({ classPrefix }) => {
    const dispatch = useDispatch();

    const nav = useSelector(leaderboardNavSelector);

    const seasons = useSelector(
        (state) =>
            state.seasons[`competition_${nav.competition.id}`]?.list ?? []
    );

    const season = seasons.find((item) => item.id === nav.season.id);
    const seasonPid = season?.providerId ?? '';

    const bettingToggle = useSelector(leaderboardBettingToggleSelector);
    const leaderboardData = useSelector((state) =>
        leaderboardDataSelector(state, seasonPid)
    );

    const { data: bettingOddsData } = useGetBrownlowBettingOddsQuery(null, {
        pollingInterval: PULSE.app.common.CONSTANTS.TIME.ONE_MINUTE_IN_MS
    });

    const status = leaderboardData?.status
        ? PULSE.app.common.match.getMatchStatus(leaderboardData.status)
        : '';

    useEffect(() => {
        if (bettingToggle.isActive === true) {
            PULSE.app.common.betting.cgmDisplay();
        } else {
            PULSE.app.common.betting.cgmHide();
        }
    }, [bettingToggle.isActive]);

    if (
        !bettingOddsData?.displayInApp ||
        !bettingOddsData?.outcomes.length ||
        (status && status === PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED)
    ) {
        return <></>;
    }

    return (
        <div className={`${classPrefix}-nav__betting-odds-toggle`}>
            <img
                className="icon"
                src={`/resources/${window.RESOURCES_VERSION}/i/elements/sports-bet-mini.png`}
            />

            <SwitchInput
                id="brownlow-tracker-betting-odds-toggle"
                label={getTranslation(
                    'label.brownlow.bettingOdds.toggle'
                ).toUpperCase()}
                isChecked={bettingToggle.isActive}
                onChange={(isActive) =>
                    dispatch(UPDATE_BETTING_TOGGLE.request({ isActive }))
                }
            />
        </div>
    );
};

BettingOddsToggle.propTypes = {
    classPrefix: PropTypes.string
};
